import { defineStore } from 'pinia'

import type { KanbanCommentsStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useKanbanCommentsStore = defineStore('kanban-comments', {
  state: (): KanbanCommentsStore => ({
    loading: false,
    comments: [],
    customerId: null,
  }),
  actions,
  getters,
})